import { assertEvent, assign } from 'xstate';

import { createLogic as createControlActorLogic } from './actors/control/controlLogic';
import { createLogic as createRecommendationsActorLogic } from './actors/recommendations/recommendationsLogic';
import { machine } from './orchestrationMachine';

export const createLogic = () =>
	machine.provide({
		actors: {
			controlActorSrc: createControlActorLogic(),
			recommendationsActorSrc: createRecommendationsActorLogic(),
		},
		guards: {
			isVariant: ({ context }) => context.draft?.metadata?.variant === 'recommendations_variant_b',
		},
		actions: {
			syncDraft: assign({
				draft: ({ event }) => {
					assertEvent(event, 'sync_draft');
					return event.draft;
				},
			}),
		},
	});
